<template>
  <div class="otps-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              Venue Analysis
              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc btn-shadow"
                @click="$router.push({ name: 'venueAnalysisDetails' })"
              >
                Venue Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div :key="data.id" class="col" v-for="data in weekData">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                Day {{ data.day }}/{{ data.month }}
                <small>Week {{ data.week }}</small>
              </h3>

              <div class="figure">
                {{ data.total_venue_check_in }}
                <small>Venue Check In</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Highest CDC Collected
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  v-model="collectedCdcDropdown"
                  @change="getVenueAnalysisChart"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="chartData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Cdc Venue
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  v-model="cdcVenueDropdown"
                  @change="getCdcVenueTopCdc"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in mostCdcVenueData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Least 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in leastCdcVenueData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Trial Venue
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  v-model="topTrialDropdown"
                  @change="getCdcVenueTopTrial"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in mostTopTrialData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Least 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in leastTopTrialData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div
          :key="index"
          v-for="(list, index) in categoryList"
          class="col"
        >
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">Current Product - {{ list.name }}</h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  v-model="categoryDropdown[index]"
                  @change="getCategoryDataByIndex(index)"
                >
                  <option
                    :key="dateIndex"
                    v-for="(data, dateIndex) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top 5</h4>
                <dl
                  :key="categoryIndex"
                  class="row no-gutters"
                  v-for="(data, categoryIndex) in categoryResultArray[index]
                    .most_count_venues"
                >
                  <dt class="col-1">
                    {{ (categoryIndex += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}%</dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Least 5</h4>

                <dl
                  :key="categoryIndex"
                  class="row no-gutters"
                  v-for="(data, categoryIndex) in categoryResultArray[index]
                    .least_count_venues"
                >
                  <dt class="col-1">
                    {{ (categoryIndex += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}%</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getDashboardDate,
  getVenueAnalysisCheckInByWeek,
  getVenueAnalysisChart,
  getCdcVenueTopTrial,
  getSellableRange,
  getSalesVenueByRangeCategory,
} from "../api";
import { getProj } from "../helpers";
import LineChart from "./chart/LineChart.vue";

export default {
  components: {
    appLineChart: LineChart,
  },
  data() {
    const thisMonday = moment().day("Monday").format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      projectId: getProj()["projId"],
      chartData: {},
      chartOption: {
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
                color: "#2B4162",
                offsetGridLines: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
                color: "#2B4162",
                offsetGridLines: false,
              },
            },
          ],
        },
        legend: {
          labels: {
            boxWidth: 10,
          },
        },
      },
      // general week data
      weeklyDateFilter: [],
      // daily check in venue data
      weekData: [],
      // highest cdc collected data
      collectedCdcDropdown: thisMonday,
      collectedChart: [],
      // topcdc venue
      cdcVenueDropdown: thisMonday,
      mostCdcVenueData: [],
      leastCdcVenueData: [],
      // top trial selected
      topTrialDropdown: thisMonday,
      mostTopTrialData: [],
      leastTopTrialData: [],
      // top benteol selected
      categoryList: [],
      categoryDropdown: [],
      categoryResultArray: [],
    };
  },
  async mounted() {
    this.getDate();
    this.getSellableRange();
    this.getVenueAnalysisCheckInByWeek();
    this.getVenueAnalysisChart();
    this.getCdcVenueTopCdc();
    this.getCdcVenueTopTrial();
  },
  methods: {
    async getDate() {
      try {
        const weekParams = { dateType: "week" };
        const result = await getDashboardDate(weekParams);
        this.weeklyDateFilter = result.data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getSellableRange() {
      try {
        const thisMonday = moment().day("Monday").format("YYYY-MM-DD");
        const result = await getSellableRange();
        window.resultdata = result;
        const categoryList = result.data.data;
        this.categoryList = categoryList;
        categoryList.forEach((data, index) => {
          this.categoryDropdown.push(thisMonday);
          this.categoryResultArray.push({
            most_count_venues: [],
            least_count_venues: [],
          });
          this.getCategoryDataByIndex(index);
        });
      } catch (err) {
        alert(err);
      }
    },
    async getVenueAnalysisCheckInByWeek() {
      try {
        let result = await getVenueAnalysisCheckInByWeek();
        this.isLoading = true;
        this.weekData = result.data.checkInByWeek;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getVenueAnalysisChart() {
      const params = {
        date: this.collectedCdcDropdown,
        dateType: "week",
        projectId: this.projectId,
      };
      try {
        const result = await getVenueAnalysisChart(params);
        this.collectedChart = result.data.charts;
        this.filterChart();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcVenueTopCdc() {
      const params = {
        date: this.cdcVenueDropdown,
        dateType: "week",
        projectId: this.projectId,
        type: "total",
      };

      try {
        const result = await getCdcVenueTopTrial(params);
        this.mostCdcVenueData = result.data.most_count_venues;
        this.leastCdcVenueData = result.data.least_count_venues;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcVenueTopTrial() {
      const params = {
        date: this.topTrialDropdown,
        dateType: "week",
        projectId: this.projectId,
        type: "trial",
      };

      try {
        const result = await getCdcVenueTopTrial(params);
        this.mostTopTrialData = result.data.most_count_venues;
        this.leastTopTrialData = result.data.least_count_venues;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCategoryDataByIndex(index) {
      try {
        const params = {
          date: this.categoryDropdown[index],
          dateType: "week",
          projectId: this.projectId,
          range: this.categoryList[index].id,
        };
        const result = await getSalesVenueByRangeCategory(params);
        this.categoryResultArray[index] = result.data;
        this.$forceUpdate();
      } catch (err) {
        alert(err);
      }
    },
    filterChart() {
      let labels = [];
      let data = [];

      this.collectedChart.forEach((item) => {
        labels.push(item.name);
        data.push(item.cdcCollected);
      });

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: "Highest CDC Collected",
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#FDCD08",
            borderWidth: 2,
            lineTension: 0,
            data: data,
          },
        ],
      };
    },
  },
};
</script>
